// @ts-check
// pwa/components/signout-modal.js — sign-out confirm modal (spec 003, Decision §2).
//
// Sign-out is a four-step flow: tap #header-signout (profile sheet footer) →
// this confirm modal → POST /api/auth/signout → full reload to clear in-memory
// state. The confirm removes the one-tap mistake on a destructive, magic-link-
// only-reversible action (brief § 5.7).

import { html } from 'lit-html';

export function signoutModalTemplate() {
  return html`
    <div class="modal-backdrop" data-modal="signout">
      <div class="modal" role="dialog" aria-modal="true" aria-labelledby="signout-modal-title">
        <h3 id="signout-modal-title" class="modal__title">Sign out?</h3>
        <p class="modal__body">You'll need to sign in again to access the Hub.</p>
        <div class="modal__actions">
          <button type="button" class="btn btn-outline" data-signout-cancel>Cancel</button>
          <button type="button" class="btn btn-destructive" data-signout-confirm>Sign out</button>
        </div>
      </div>
    </div>
  `;
}

/** @param {HTMLElement} root  @param {() => void} onConfirm */
export function wireSignoutModal(root, onConfirm) {
  const backdrop = /** @type {(HTMLElement & { _open?: () => void })|null} */ (root.querySelector('[data-modal="signout"]'));
  if (!backdrop) return;
  const onKey = (e) => { if (e.key === 'Escape') { e.preventDefault(); close(); } };
  function close() { backdrop.classList.remove('is-open'); document.removeEventListener('keydown', onKey); }
  backdrop.querySelector('[data-signout-cancel]')?.addEventListener('click', close);
  backdrop.addEventListener('click', (e) => { if (e.target === backdrop) close(); });
  backdrop.querySelector('[data-signout-confirm]')?.addEventListener('click', () => onConfirm?.());
  backdrop._open = () => {
    backdrop.classList.add('is-open');
    document.addEventListener('keydown', onKey);
    /** @type {HTMLElement|null} */ (backdrop.querySelector('[data-signout-confirm]'))?.focus();
  };
}

export function openSignoutModal(root) { root.querySelector('[data-modal="signout"]')?._open?.(); }
